module.exports = __webpack_public_path__ + "img/fondo3.4f27ca3c.jpg";